import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../routes';

const Business = ({ banner, mg }) => {
  if (banner === null) {
    return null;
  }
  const url = banner.link.url.replace('internal:', '');
  return (
    <div id="business" className={mg}>
      <div className="wrapper">
        <div className="business caps">
          <div className="business__block">
            <div
              className="title gpbol"
              data-aos="fade-left"
              data-aos-delay="30"
              data-aos-duration="500"
              data-aos-offset="-100"
            >
              {banner.title}
            </div>
            <div
              className="gpbol"
              data-aos="fade-left"
              data-aos-delay="30"
              data-aos-offset="-100"
              data-aos-duration="1000"
              dangerouslySetInnerHTML={{ __html: banner.body }}
            />
          </div>
          <div
            className="business__block"
            data-aos="zoom-in"
            data-aos-delay="30"
            data-aos-offset="-100"
            data-aos-duration="300"
          >
            <Link to={url}>
              <a>
                <button className="btn gpbol caps">{banner.link.title}</button>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

Business.propTypes = {
  banner: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    link: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  mg: PropTypes.string,
};

Business.defaultProps = {
  banner: null,
  mg: '',
};

export default Business;
